import templateUrl from "emun.cart/approve-cart/approve-cart.htm";
import "emun.cart/approve-cart/approve-cart.scss";
import controller from "emun.cart/approve-cart/approve-cart.controller";

export default {
  templateUrl,
  controller,
  bindings: {
    autoApprove: "<?",
    cartId: "@",
    token: "@"
  }
};
